import { Space, Typography } from 'antd';

import { BatteryIcon } from './battery-icon';
import { CombinedShapeIcon } from './combined-shape-icon';
import { WifiIcon } from './wifi-icon';
import moment from 'moment';
import styled from '@emotion/styled';

export function SpMockupPhone({ style, children }) {
  const times = moment().format('HH:mm');
  return (
    <MockupIphone style={style}>
      <Space style={{ justifyContent: 'space-between' }}>
        <Typography.Text strong>{times}</Typography.Text>
        <div style={{ display: 'flex', gap: 3 }}>
          <CombinedShapeIcon color="#000" />
          <WifiIcon color="#000" />
          <BatteryIcon color="#000" />
        </div>
      </Space>

      <br />
      <br />
      {children}
    </MockupIphone>
  );
}

const MockupIphone = styled.div({
  borderRadius: 25,
  borderColor: '#000',
  borderWidth: 9,
  borderStyle: 'solid',
  height: 600,
  width: 300,
  position: 'relative',
  background: '#EAEAEA',
  backgroundImage: 'url(/img/mockup-phone-bg.png)',
  backgroundSize: 'cover',
  padding: '5px 14px',
  '@media screen and (max-width: 1300px)': {
    height: 480,
  },
  '@media screen and (max-width: 1200px)': {
    width: 220,
  },
  '@media screen and (max-width: 1100px)': {
    width: 200,
    height: 450,
  },
  '@media screen and (max-width: 768px)': {
    height: 650,
    width: 300,
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    background: '#000',
    width: '42%',
    height: 25,
    zIndex: 10,
    top: 0,
    left: 'calc((100% - 42%) / 2)',
    borderBottomLeftRadius: 16.5,
    borderBottomRightRadius: 16.5,
    '@media screen and (max-width: 1300px)': {
      width: '40%',
      height: 18,
      left: 'calc((100% - 40%) / 2)',
      borderBottomLeftRadius: 16,
      borderBottomRightRadius: 16,
    },
    '@media screen and (max-width: 1200px)': {
      width: '36%',
      height: 15,
      left: 'calc((100% - 36%) / 2)',
      borderBottomLeftRadius: 15,
      borderBottomRightRadius: 15,
    },
    '@media screen and (max-width: 1100px)': {
      width: '32%',
      height: 12,
      left: 'calc((100% - 32%) / 2)',
      borderBottomLeftRadius: 12,
      borderBottomRightRadius: 12,
    },
    '@media screen and (max-width: 768px)': {
      width: '42%',
      height: 25,
      left: 'calc((100% - 42%) / 2)',
      borderBottomLeftRadius: 16.5,
      borderBottomRightRadius: 16.5,
    },
  },
  '.ant-typography': {
    color: '#000',
  },
});
